import { Dialog } from '../Dialog/Dialog';
import s from './ImageViewer.module.css';

export type ImageViewerProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  alt: string;
};

/** Full-screen photo. Pinch to zoom (native browser zoom on the image), X or Esc to close. */
export function ImageViewer({ open, onOpenChange, src, alt }: ImageViewerProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={alt}
      hideTitle
      variant="fullscreen"
      className={s.viewer}
    >
      <div className={s.stage}>
        <img src={src} alt={alt} className={s.image} referrerPolicy="no-referrer" />
      </div>
    </Dialog>
  );
}
